import React from 'react';
import '../css/footer/Footer.css';
import CTAButtons from './CTAButtons';
import SEO from './SEO';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // For contact, scroll to contact-info section for better mobile experience
      if (sectionId === 'contact') {
        const contactInfo = document.getElementById('contact-info');
        if (contactInfo) {
          // Add offset for mobile to ensure contact info is visible
          const isMobile = window.innerWidth <= 768;
          const offset = isMobile ? 80 : 20;
          
          const elementPosition = contactInfo.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth'
          });
          return;
        }
      }
      
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <SEO 
        title="Contact Samapaw - Get in Touch with Financial Experts"
        description="Contact Samapaw for wealth management services. Reach Samapaw Sampatti Pvt Ltd located in DLF Phase 4, Gurugram. Call +918287133175 or email samapawsampatti@gmail.com. Samapaw office hours: Mon-Fri 9AM-6PM."
        keywords="contact Samapaw, contact Samapaw Sampatti, Samapaw contact, Samapaw wealth management contact Gurugram, Samapaw financial services contact, Samapaw investment advisory contact Haryana, Samapaw business hours, Samapaw office address DLF Phase 4, Sama paw contact"
        section="contact"
      />
      <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-grid">
            <div className="footer-section company-info">
              <div className="footer-logo">
                <h3>Samapaw Sampatti</h3>
                <span>Private Limited</span>
              </div>
              <p className="company-motto">Creating Wealth</p>
              <p className="company-description">
                Investment, development and trading in movable and immovable property. 
                Your trusted partner in building sustainable wealth for the future.
              </p>

            </div>

            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><button onClick={() => scrollToSection('home')}>Home</button></li>
                <li><button onClick={() => scrollToSection('about')}>About Us</button></li>
                <li><button onClick={() => scrollToSection('services')}>Services</button></li>
                <li><button onClick={() => scrollToSection('team')}>Team</button></li>
                <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Our Services</h4>
              <ul className="footer-links">
                <li><button onClick={() => scrollToSection('services')}>Wealth Management</button></li>
                <li><button onClick={() => scrollToSection('services')}>Portfolio Management</button></li>
                <li><button onClick={() => scrollToSection('services')}>Business Debt Provision</button></li>
                <li><button onClick={() => scrollToSection('services')}>Property Investment</button></li>
                <li><button onClick={() => scrollToSection('services')}>Financial Consultation</button></li>
              </ul>
            </div>

            <div id="contact-info" className="footer-section contact-info">
              <h4>Contact Information</h4>
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <div>
                  <p>Office Address</p>
                  <p>3701, 4th Floor, DLF Phase 4, Sector 28, Gurugram, Haryana, India</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone"></i>
                <div>
                  <p>Phone</p>
                  <p>+918287133175</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <div>
                  <p>Email</p>
                  <p>samapawsampatti@gmail.com</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="fas fa-clock"></i>
                <div>
                  <p>Business Hours</p>
                  <p>Mon - Fri: 9:00 AM - 6:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          <div id="contact-cta" className="footer-cta">
            <div className="cta-content">
              <h3>Ready to Build Your Wealth?</h3>
              <p>Get in touch with our experts today and start your journey towards financial success.</p>
              <CTAButtons />
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2024 Samapaw Sampatti Pvt Ltd. All rights reserved.</p>
            </div>
            <div className="footer-bottom-links">
              <button type="button" onClick={() => window.alert('Privacy Policy - Coming Soon')}>Privacy Policy</button>
              <button type="button" onClick={() => window.alert('Terms of Service - Coming Soon')}>Terms of Service</button>
              <button type="button" onClick={() => window.alert('Disclaimer - Coming Soon')}>Disclaimer</button>
            </div>
            <button className="scroll-top" onClick={scrollToTop}>
              <i className="fas fa-arrow-up"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;